import { IS_DEVELOPMENT } from 'constants/common';

export function generateProposalPageURL(proposalId: string, vendorGUID: string): string {
  return `https://app${
    IS_DEVELOPMENT ? '.dev' : ''
  }.trnsact.com/ps/?vendorGUID=${vendorGUID}&proposalId=${proposalId}&viewOnly=true`;
}
